import React, { useState } from "react";
import { Stack, Button, Card } from "react-bootstrap";
import { renderRejectionMessage } from "../utils";
import { DocumentCollectionLayout } from "@/components/Modal/DocumentCollection";
import StatusTag from "@/components/Common/StatusTag";
import { STATUS_MAP } from "@/utils/constant";
import { useModalQueryParams } from "@/utils/useModalQueryParams";

import '../dashboard_styles.css';

function UploadDocumentsCard({ loanDetails, refreshStatus }) {
  const [showLoanModal, setShowLoanModal] = useModalQueryParams('upload-documents', false);
  const { status, rejection_reason } = loanDetails || {};
  const stepComplete = status === 'verified';

  let description = ''
  if (status === 'verified') {
    description = "We've successfully verified your financial documents."
  } else if (status == 'completed') {
    description = "We are verifying your documents. You can click upload to modify any documents."
  } else {
    description = "Please upload your financial documents."
  }

  return (
    <Card className={`dashboardActionCard activeCard`} data-testid="fincobox-los-upload-documents-card">
      <Stack direction="horizontal" gap={3}>
        <Stack gap={2} className="actionContent">
          <h4 className="actionCardTitle dash_statusDiv" data-testid="fincobox-los-upload-documents-heading">
            Upload Documents
            {status && (
              <StatusTag
                status={status}
                stepComplete={stepComplete}
                label={STATUS_MAP[status]?.label || "Unknown"}
                data-testid="fincobox-los-upload-documents-status"
              />
            )}
          </h4>
          <p className="actionCardDescription" data-testid="fincobox-los-upload-documents-description">{description}</p>
        </Stack>

        <div>
          <Button
            variant="primary"
            onClick={() => setShowLoanModal(true)}
            className="actionButton"
            color="primary"
            data-testid="fincobox-los-upload-documents-btn"
          >
            {stepComplete ? 'VIEW' : 'UPLOAD'}
          </Button>
        </div>
      </Stack>
      {renderRejectionMessage(status, rejection_reason)}
      {showLoanModal && (
        <DocumentCollectionLayout
          loanId={loanDetails?.uuid}
          show={showLoanModal}
          onHide={() => { refreshStatus(); setShowLoanModal(false); }}
        />
      )}
    </Card >
  );
}

export default UploadDocumentsCard;
